import { Button, FormControl, MenuItem, Select } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import readXlsxFile from 'read-excel-file';
import {
  addExelBulkApplicantsAsync,
  addExelBulkApplicantsStartReducer,
} from '../../../_redux/_services/ApplicantsSlice';
import { customFieldsAsync } from '../../../_redux/_services/UserManagerSlice';
import { updateSnackbar } from '../../../_redux/SnackbarSlice';
import { formatFileSize } from '../../../_utilities/utilities';
import DynamicTable from '../../../components/DynamicTable/DynamicTable';
import { useUnsavedChangesAlert } from '../../../hooks/useUnsavedChangesAlert';
import './ApplicantsRenderExcelData.css';
import Cookies from 'js-cookie';

import { GetUserId, getAttributes } from '../../../_utilities/getUserInfo';
const initalState = { data: null, message: '', isloader: true };

const ApplicantsRenderExcelData = (props) => {
  const [customFields, setCustomFields] = useState([]);
  const [uploadFile, setUploadFile] = useState(null);
  const [excelData, setExcelData] = useState([]);
  const [generateColumns, setGenerateColumns] = useState([]);
  const [showPreviewSection, setShowPreviewSection] = useState(false);
  const [showStatusResponse, setShowStatusResponse] = useState(false);
  const [statusTableData, setStatusTableData] = useState(false);
  const [tableColumns, setTableColumns] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [config, setConfig] = useState(configuration);
  const fileInputRef = useRef(null);
  const [isDirty, setIsDirty] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  useUnsavedChangesAlert(isDirty);
  const [selectedSourceValue, setSelectedSourceValue] = useState({});
  const [sourceValue, setSourceValue] = useState([]);

  const customFieldsDataResponse = useSelector(
    (state) => state.CustomFields.data
  );
  const exelBulkApplicantsResponse = useSelector(
    (state) => state.AddExelBulkApplicants.data
  );

  useEffect(() => {
    async function init() {
      const userId = await GetUserId();
      dispatch(customFieldsAsync(userId));
    }
    init();
  }, []);

  useEffect(() => {
    async function getExcelData() {
      if (location.state?.excelData && location.state?.uploadedFile) {
        //!isDirty &&
        location.state.uploadedFile['formatSize'] = formatFileSize(
          location.state.uploadedFile.size
        );
        setUploadFile(location.state.uploadedFile);
        const headers = location.state.excelData[0];
        const data = location.state.excelData;
        setGenerateColumns(headers);
        setSelectedSourceValue(location.state.sourced);
        setExcelData(data);
        setCustomFields([...defaultFields]);
        const userId = await GetUserId();
        dispatch(customFieldsAsync(userId));
        let updateConfig = { ...configuration, totalRecords: data.length - 1 };
        setConfig(updateConfig);
      } else if (!uploadFile || excelData.length === 0) {
        navigate(getApplicantPath());
      }
    }
    getExcelData();
  }, []); //location, isDirty, uploadFile, excelData, configuration, GetUserId

  useEffect(() => {
    if (customFieldsDataResponse?.length > 0) {
      const columns = customFieldsDataResponse
        .filter(
          (x) =>
            x.moduleId.toString() === '2' &&
            ['custom', 'default'].includes(x.fieldType)
        )
        .map((x) => ({
          field: x.fieldName,
          label: x.fieldName,
          value: '',
          fieldType: 'custom',
          dataType: x.dataType,
        }));
      setCustomFields((prev) => {
        const existing = prev.map((f) => f.field);
        const fresh = columns.filter((c) => !existing.includes(c.field));
        return [...prev, ...fresh];
      });
      const rawSourcedValues = customFieldsDataResponse.filter(
        (x) =>
          x.moduleId.toString() === '2' &&
          ['default'].includes(x.fieldType) &&
          x.fieldName === 'Source'
      );
      if (rawSourcedValues.length > 0 && rawSourcedValues[0].customValues) {
        let values = JSON.parse(rawSourcedValues[0].customValues);
        let modifiedCustomValues = values.filter(
          (list) =>
            ![
              'Cloud Sourcing',
              'Employee Portal',
              'Vendor Sourcing',
              'Job Board Portal',
            ].includes(list)
        );
        setSourceValue(modifiedCustomValues);
      } else {
        console.warn(
          'No matching Source field found or customValues is missing'
        );
        setSourceValue([]);
      }
    }
  }, [customFieldsDataResponse]);

  const onChangeHandler = (value, index, type) => {
    const newFields = [...customFields];
    if (type === 'Source') {
      let sourceIndex = sourceValue.findIndex((x) => x === value);
      if (sourceIndex !== -1) {
        setSelectedSourceValue({ id: sourceIndex + 1, name: value });
      }
    } else {
      newFields[index] = { ...newFields[index], value: value };
      setCustomFields(newFields);
    }
    setIsDirty(true);
  };

  const onPreviewHandler = () => {
    if (!excelData || excelData.length === 0) return;
    const headers = excelData[0];
    const rows = excelData.slice(1);
    const columnsArr = [];
    const columnIndexMap = {};
    customFields.forEach((fieldObj, index) => {
      if (fieldObj.value) {
        const colIndex = headers.findIndex((h) => h === fieldObj.value);
        if (colIndex !== -1) {
          columnsArr.push({
            id: index,
            displayName: fieldObj.label,
            mappingName: fieldObj.field,
          });
          columnIndexMap[fieldObj.field] = colIndex;
        }
      }
    });
    const dataArr = rows.map((row) => {
      const dataObj = {};
      Object.keys(columnIndexMap).forEach((field) => {
        const colIndex = columnIndexMap[field];
        dataObj[field] = row[colIndex] ?? '';
      });
      return dataObj;
    });
    setConfig({ ...config, totalRecords: dataArr.length });
    setTableColumns(columnsArr);
    setTableData(dataArr);
    setIsDirty(true);
    setShowPreviewSection(true);
  };

  const fileImgHandler = (event) => {
    event.preventDefault();
    let uploadFile = event.target.files && event.target.files[0];
    if (!uploadFile) {
      return;
    }
    var allowedExtensions = /(\.xls|\.xlsx)$/i;
    if (!allowedExtensions.test(uploadFile.name)) {
      dispatch(
        updateSnackbar({
          type: 'error',
          message: 'Invalid file format. Please upload Excel file only',
        })
      );
      return;
    }
    uploadFile['formatSize'] = formatFileSize(uploadFile.size);
    setUploadFile(uploadFile);
    readXlsxFile(uploadFile).then((rows) => {
      if (!rows || rows.length === 0) {
        dispatch(
          updateSnackbar({ type: 'error', message: 'Excel file is empty' })
        );
        return;
      }

      const headers = rows[0]; // first row = header

      let invalidInfo = null; // store first failing row/col

      // scan all rows starting from row 2 (index 1)
      rows.forEach((row, rowIndex) => {
        row.forEach((cell, colIndex) => {
          // allow: string, number, empty cell (null)
          const isValid =
            cell === null ||
            typeof cell === 'string' ||
            typeof cell === 'number';

          if (!isValid && invalidInfo === null) {
            invalidInfo = {
              row: rowIndex + 1, // +1 for human readable
              col: colIndex + 1,
              header: headers[colIndex] || `Column ${colIndex + 1}`,
              value: cell,
            };
          }
        });
      });

      if (invalidInfo) {
        dispatch(
          updateSnackbar({
            type: 'error',
            message: `Invalid data in ${invalidInfo.header} (Row ${invalidInfo.row}, Column ${invalidInfo.col}), Only text/number values allowed.`,
          })
        );
        return;
      }
      const data = rows; //.slice(1);
      setGenerateColumns(headers);
      setExcelData(data);
      let updateConfig = { ...configuration };
      updateConfig.totalRecords = data.length - 1;
      setConfig(updateConfig);
      setIsDirty(true);
      setCustomFields((prev) => prev.map((field) => ({ ...field, value: '' })));
    });
    event.target.value = '';
  };

  const onSaveExcelDataHandler = async () => {
    if (tableData.length === 0) return;
    const adminDetails = await getAttributes();
    const userId = adminDetails?.[0]?.userId;

    const payloadArr = await Promise.all(
      tableData.map(async (item) => {
        const payload = { ...payloadFormat };
        if (item.firstName) payload.firstName = item.firstName;
        if (item.lastName) payload.lastName = item.lastName;
        if (item.contactNumber)
          payload.contactNumber = item.contactNumber.toString();
        if (item.alternateContactNumber)
          payload.alternateContactNumber =
            item.alternateContactNumber.toString();
        if (item.emailId) payload.emailId = item.emailId;
        if (item.skillDetails) {
          const skillList = item.skillDetails.split(',').map((s) => s.trim());
          payload.skillDetails = JSON.stringify(
            skillList.map((skill) => ({
              name: skill,
              numberOfMonths: null,
              lastUsed: null,
            }))
          );
        }
        if (item.certification) {
          payload.certification = JSON.stringify(
            item.certification.split(',').map((x) => x.trim())
          );
        }
        if (item.totalExperience)
          payload.totalExperience = item.totalExperience;
        if (item.linkedIn) payload.linkedIn = item.linkedIn;
        payload.userId = userId;
        payload.rawData = JSON.stringify(item);
        const reservedKeys = [
          'firstName',
          'lastName',
          'contactNumber',
          'alternateContactNumber',
          'emailId',
          'skillDetails',
          'certification',
          'totalExperience',
          'linkedIn',
        ];
        const customArr = Object.keys(item)
          .filter((key) => !reservedKeys.includes(key))
          .map((key) => ({ key, value: item[key] }));
        if (customArr.length > 0) {
          payload.customFields = JSON.stringify(customArr);
        }
        payload.resumeSource = selectedSourceValue.name;
        payload.resumesourceId = selectedSourceValue.id;
        return payload;
      })
    );
    dispatch(addExelBulkApplicantsAsync({ applicants: payloadArr }));
  };

  useEffect(() => {
    if (exelBulkApplicantsResponse && exelBulkApplicantsResponse.length > 0) {
      setStatusTableData(exelBulkApplicantsResponse);
      setCustomFields([...defaultFields]);
      setShowStatusResponse(true);
      setConfig({ ...config, currentPage: 1 });
      setIsDirty(true);
      dispatch(addExelBulkApplicantsStartReducer(initalState));
    }
  }, [exelBulkApplicantsResponse]);

  const onNavigateHandler = () => {
    setIsDirty(false);
    setTimeout(() => {
      navigate(getApplicantPath());
    }, 200);
  };

  useEffect(() => {
    console.log('customFields in render:', customFields);
  }, [customFields]);

  return (
    <>
      {!showPreviewSection && !showStatusResponse ? (
        <div className="render-exceldata-section">
          <h1>Import Applicants from Excel</h1>
          <p>
            Map your Excel columns to applicant fields to import data
            seamlessly.
          </p>
          <div className="render-exceldata">
            <p>
              Uploaded File{' '}
              {/* <span>{excelData?.length - 1 ?? 0} records found</span> */}
              <span>
                {Math.max((excelData?.length ?? 0) - 1, 0)} records found
              </span>
            </p>
            {uploadFile && (
              <div className="uploadfiledata">
                <img
                  src={process.env.PUBLIC_URL + '/assests/img/excelIcon.svg'}
                  alt=""
                />
                <h5>
                  {uploadFile.name}
                  <p>{uploadFile.formatSize} • Uploaded successfully</p>
                </h5>
                <button
                  type="button"
                  style={{
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                  }}
                  onClick={() => {
                    fileInputRef.current.click();
                  }}
                >
                  <span>
                    <img
                      src={process.env.PUBLIC_URL + '/assests/img/upload.svg'}
                      alt=""
                    />{' '}
                    Update File
                  </span>
                  <input
                    ref={fileInputRef}
                    type="file"
                    id="fileId"
                    style={{ display: 'none' }}
                    onChange={(e) => fileImgHandler(e)}
                  />
                </button>
              </div>
            )}

            <div className="mapping-exceldata-tocolumns">
              <h4>Field Mapping</h4>
              {customFields.map((field, index) => {
                const dropdownObj =
                  field.label !== 'Source' ? generateColumns : sourceValue;
                const selectedValue =
                  field.label !== 'Source'
                    ? field.value
                    : selectedSourceValue?.name;
                return (
                  <section key={index}>
                    <label>{field.label}</label>
                    <div style={{ width: '25%' }}>
                      <FormControl fullWidth>
                        <Select
                          value={selectedValue}
                          size="small"
                          name="Sourced From"
                          autoComplete="off"
                          onChange={(e) =>
                            onChangeHandler(e.target.value, index, field.label)
                          }
                          style={{ width: '100%', borderRadius: '4px' }}
                          displayEmpty
                          renderValue={(selected) => {
                            if (selected?.length === 0) {
                              return <small>Select column...</small>;
                            }
                            return selected;
                          }}
                        >
                          {dropdownObj?.map((name, index) => {
                            if (name) {
                              return (
                                <MenuItem
                                  className="selectOptions"
                                  key={index}
                                  value={name}
                                >
                                  {name}
                                </MenuItem>
                              );
                            }
                          })}
                        </Select>
                      </FormControl>
                    </div>
                  </section>
                );
              })}
            </div>
          </div>
          <div style={{ textAlign: 'right' }}>
            <Button
              variant="text"
              type="button"
              className="addApplicantcancelBtn"
              size="small"
              onClick={() => {
                navigate(getApplicantPath());
              }}
            >
              <Link
                href="#"
                style={{ color: 'red', width: '5rem', fontSize: '14px' }}
                underline="always"
              >
                {' '}
                Cancel
              </Link>
            </Button>
            <Button
              type="button"
              variant="contained"
              size="small"
              disabled={customFields.filter((x) => x.value).length === 0}
              className="saveBtn"
              onClick={onPreviewHandler}
            >
              Preview
            </Button>
          </div>
        </div>
      ) : showPreviewSection && !showStatusResponse ? (
        <div className="render-exceldata-footer">
          <h4>Preview</h4>
          {/* preview table format */}
          {tableData && tableData.length > 0 && (
            <DynamicTable
              config={config}
              data={tableData}
              colmns={tableColumns}
              actionDropdown={[]}
              filterValue={''}
              searchKeyWord=""
              actions={{}}
              addModel={{}}
              noDataText="No Applicants Found"
              onReceiveActionProps={(type, obj) => console.log(type, obj)}
            />
          )}
          <div style={{ textAlign: 'right', marginTop: '40px' }}>
            <Button
              variant="text"
              type="button"
              className="addApplicantcancelBtn"
              size="small"
              onClick={() => {
                setShowPreviewSection(false);
              }}
            >
              <Link
                href="#"
                style={{ fontSize: '14px', color: '#000000' }}
                underline="always"
              >
                {' '}
                Back
              </Link>
            </Button>
            <Button
              type="button"
              variant="contained"
              size="small"
              className="saveBtn"
              onClick={onSaveExcelDataHandler}
            >
              Save
            </Button>
          </div>
        </div>
      ) : (
        showStatusResponse && (
          <div className="render-exceldata-footer">
            <h4>
              Please Verify the Status of Applicants
              <Link
                href="#"
                style={{
                  fontSize: '14px',
                  color: 'red',
                  float: 'right',
                  marginTop: '7px',
                }}
                onClick={onNavigateHandler}
                underline="always"
              >
                {' '}
                Close
              </Link>
            </h4>
            {statusTableData && statusTableData.length > 0 && (
              <DynamicTable
                config={config}
                data={statusTableData}
                colmns={statusTableColumn}
                actionDropdown={[]}
                filterValue={''}
                searchKeyWord=""
                actions={{}}
                addModel={{}}
                noDataText="No Applicants Found"
                onReceiveActionProps={(type, obj) => console.log(type, obj)}
              />
            )}
          </div>
        )
      )}
    </>
  );
};

export default React.memo(ApplicantsRenderExcelData);

const payloadFormat = {
  firstName: '',
  lastName: '',
  contactNumber: '',
  alternateContactNumber: '',
  emailId: '',
  skillDetails: [],
  totalExperience: null,
  certification: [],
  linkedIn: '',
  customFields: '', //dynamic
  userId: '',
  source: 'ATS',
  resumesourceId: '',
  candidateStatus: 'New',
  csAssociatedJobs: '',
  eAssociatedJobs: '',
  vsAssociatedJobs: '',
  rawData: '',
};

const defaultFields = [
  {
    field: 'firstName',
    label: 'First Name',
    value: '',
    fieldType: 'default',
    dataType: '',
  },
  {
    field: 'lastName',
    label: 'Last Name',
    value: '',
    fieldType: 'default',
    dataType: '',
  },
  {
    field: 'contactNumber',
    label: 'Contact Number',
    value: '',
    fieldType: 'default',
    dataType: '',
  },
  {
    field: 'alternateContactNumber',
    label: 'Alternate Contact Number',
    value: '',
    fieldType: 'default',
    dataType: '',
  },
  {
    field: 'emailId',
    label: 'Email ID',
    value: '',
    fieldType: 'default',
    dataType: '',
  },
  {
    field: 'skillDetails',
    label: 'Skills',
    value: '',
    fieldType: 'default',
    dataType: '',
  },
  {
    field: 'certification',
    label: 'Certifications',
    value: '',
    fieldType: 'default',
    dataType: '',
  },
  {
    field: 'totalExperience',
    label: 'Total Experience',
    value: '',
    fieldType: 'default',
    dataType: '',
  },
  {
    field: 'linkedIn',
    label: 'LinkedIn',
    value: '',
    fieldType: 'default',
    dataType: '',
  },
];

const configuration = {
  isSearchbar: false,
  isPaging: true,
  isDropdownActions: false,
  isCheckbox: false,
  isActions: false,
  recordperPage: 10,
  currentPage: 1,
  totalRecords: 0,
  isTotalCount: false,
  totalRecordsCount: 0,
  totalRecordsCountText: '',
  limitData: 20,
  isCheckAlignRight: false,
  isPaginationTop: true,
  isSearchServer: false,
  isPagingServer: false,
  isPageRange: false,
};

const getApplicantPath = () =>
  Cookies.get('applicantViewPreference') || '/ats/layout/applicants/landing';

const statusTableColumn = [
  {
    id: 1,
    displayName: 'Applicant Code',
    mappingName: 'applicantCode',
    isEdit: true,
    nagigate: '/ats/layout/applicants/view',
    openNewTab: true,
  },
  { id: 2, displayName: 'Full Name', mappingName: 'fullName' },
  { id: 3, displayName: 'Contact number', mappingName: 'contactNumber' },
  { id: 4, displayName: 'Email address', mappingName: 'emailId' },
  { id: 5, displayName: 'Status', mappingName: 'status', isClassDynamic: true },
];
